<!-- 我的回收站更多操作 -->
<template>
  <div>
    <!-- 文件夹操作菜单 -->
    <van-action-sheet v-model="showFolder" :actions="folderMoreList" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFolder" />
    <!-- 文件操作菜单 -->
    <van-action-sheet v-model="showFile" :actions="fileMoreList" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFile" />

    <!-- 删除弹框 -->
    <van-popup v-model="showDel" round @close="showDel = false">
      <div class="modalStyle">
        <div class="text">要彻底删除该文件吗？</div>
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="showDel = false" />
          <van-button text="确认" type="info" round @click="confirmDel" />
        </div>
      </div>
    </van-popup>
    <!-- 恢复弹框 -->
    <van-popup v-model="showRecovery" round @close="showRecovery = false">
      <div class="modalStyle">
        <div class="text">是否确定恢复？</div>
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="showRecovery = false" />
          <van-button text="确认" type="info" round @click="confirmRecovery" />
        </div>
      </div>
    </van-popup>
    <!-- 属性弹框 -->
    <van-popup v-model="attributeShow" position="bottom">
      <div class="attributeContent">
        <div class="attributeItem">
          <span>文件大小：</span>
          <span class="attributeItemData">{{ Pitem.isFolder === 1 ? "--" : Pitem.fileSize }}</span>
        </div>
        <div class="attributeItem">
          <span>文档路径：</span>
          <span class="attributeItemData">{{ Pitem.position }}</span>
        </div>
        <div class="attributeItem">
          <span>删除时间：</span>
          <span class="attributeItemData">{{ Pitem.operDate }}</span>
        </div>
        <div class="attributeItem">
          <span>删除人：</span>
          <span class="attributeItemData">{{ Pitem.operUserName }}</span>
        </div>
      </div>
      <div class="attributeClose" @click="attributeClose">取消</div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import docService from "@/CommonDP/service/doc-service";
import { debounce } from "lodash-es";

export default {
  data() {
    return {
      // 文件夹操作菜单
      folderMoreList: [],
      folderPriviList: [
        { name: "删除", Privi: this.$allPerms.MYRECYCLE_DALE },
        { name: "恢复", Privi: this.$allPerms.MYRECYCLE_RECOVERY },
        { name: "属性", Privi: "" }
      ],
      // 文件操作菜单
      fileMoreList: [],
      filePriviList: [
        { name: "删除", Privi: this.$allPerms.MYRECYCLE_DALE },
        { name: "恢复", Privi: this.$allPerms.MYRECYCLE_RECOVERY },
        { name: "属性", Privi: "" }
      ],
      showFolder: false,
      showFile: false,
      Pitem: {}, // 当前操作的文档

      showDel: false, // 删除弹框
      showRecovery: false, // 恢复弹框
      attributeShow: false // 属性弹框
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId // 当前企业Id
    })
  },
  onLoad() {},
  mounted() {},
  methods: {
    // 设置文件夹权限
    setFolderPrivi(items) {
      this.Pitem = items || {};
      this.folderMoreList = this.folderPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFolder = true;
    },
    // 设置文件权限
    setFilePrivi(items) {
      this.Pitem = items || {};
      this.fileMoreList = this.filePriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFile = true;
    },
    // 关闭事件
    close() {
      this.showFolder = false;
      this.showFile = false;
    },

    // 文件夹菜单事件
    selectFolder(val) {
      if (val.name === "删除") this.deleteRow();
      if (val.name === "恢复") this.recovery();
      if (val.name === "属性") this.queryAttribute();
    },
    // 文件菜单事件
    selectFile(val) {
      if (val.name === "删除") this.deleteRow();
      if (val.name === "恢复") this.recovery();
      if (val.name === "属性") this.queryAttribute();
    },

    // 删除
    deleteRow() {
      this.close();
      this.showDel = true;
    },
    // 确定删除
    async confirmDel() {
      const fileIds = [];
      const folderIds = [];
      const prjId = "MyDoc";
      if (this.Pitem.folderType) fileIds.push(this.Pitem.folderId);
      if (!this.Pitem.folderType) folderIds.push(this.Pitem.folderId);
      const params = { fileIds, folderIds, prjId };
      await docService.recycldelete(params);
      Notify({ type: "success", message: "删除成功!" });
      this.showDel = false;
      this.$emit("toRefresh");
    },
    // 恢复
    recovery() {
      this.close();
      this.showRecovery = true;
    },
    // 确定恢复
    confirmRecovery: debounce(async function () {
      this.showRecovery = false;
      const fileIds = [];
      const folderIds = [];
      const prjId = "MyDoc";
      if (this.Pitem.folderType) fileIds.push(this.Pitem.folderId);
      if (!this.Pitem.folderType) folderIds.push(this.Pitem.folderId);
      const params = { fileIds, folderIds, prjId };
      await docService.recyclerestore(params);
      Notify({ type: "success", message: "恢复成功!" });
      this.$emit("toRefresh");
    }, 1000),
    // 属性
    queryAttribute() {
      this.close();
      this.attributeShow = true;
    },
    // 关闭属性
    attributeClose() {
      this.attributeShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .uActionSheetStyle {
  .van-action-sheet__content {
    max-height: 50vh;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #e5e8f1 !important;
    .van-action-sheet__name {
      font-size: 16px;
      color: var(--key-color);
    }
  }

  .van-action-sheet__cancel {
    font-size: 16px;
    color: #007af5;
  }

  .van-action-sheet__gap {
    height: 1px !important;
    background-color: #e5e8f1 !important;
  }
}

.modalStyle {
  width: 90vw;
  padding: 3vh 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .buttonSlider {
    width: 100%;
    padding: 2vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

.attributeContent {
  max-height: 240px;
  padding: 20px;

  .attributeItem {
    white-space: nowrap;
    overflow: overlay !important;
    overflow: auto;
    span {
      font-size: 16px;
      line-height: 40px;
    }
    .attributeItemData {
      color: var(--key-color);
    }
  }
}

.attributeClose {
  border-top: 1px solid #e5e8f1 !important;
  font-size: 16px !important;
  color: #007af5 !important;
  line-height: 50px;
  text-align: center;
}
</style>
